import { Component, OnInit, ViewChild } from "@angular/core";
import { PanoramicService } from "../../../view/services/panoramic.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ModalWindowComponent } from "../modal-window/modal-window.component";
import { LoginComponent } from "../login/login.component";
import { environment } from "../../../../environments/environment";
import { LoginService } from "../../services/login/login.service";
import { MapService } from "../../../view/services/map.service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SecurityContext } from "@angular/core";
import { SidebarComponent } from "../sidebar/sidebar.component";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  @ViewChild('sidenav') sidenav: SidebarComponent;

  activatedViewMap: Boolean = true;
  activatedViewPanoramic: Boolean = false;
  activatedViewDashboard: Boolean = false;
  login: Boolean = environment.login;
  ver = environment.version;
  proyect = environment.project;
  safeUrl: SafeResourceUrl;
  splitAreaSizeMap = 50;
  splitAreaSizePanoramic = 50;
  sidenavView:boolean =  false;

  constructor(
    protected panoramicService: PanoramicService,
    protected dialog: MatDialog,
    protected loginService: LoginService,
    public mapService: MapService,
    public domSanitizer: DomSanitizer,
  ) { }



  ngOnInit() {
    //open Login in start app
    if (this.login) {
      this.openLogin();
    }
    //sanitize dashboard url
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.domSanitizer.sanitize(SecurityContext.URL, environment.dashboardUrl));
  }

  openSidenav() {
    this.sidenav.toggle();
  }

  openLogin() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.backdropClass = "backdropLogin";
    this.dialog.open(LoginComponent, dialogConfig);
  }

  openSettingsLayer() {
    const dialogConfig2 = new MatDialogConfig();
    dialogConfig2.autoFocus = false;
    this.dialog.open(ModalWindowComponent, dialogConfig2);
  }

  changeViewMap() {
    this.activatedViewMap = true;
    this.activatedViewPanoramic = false;
    this.mapService.removeMarkers();
  }

  changeViewMixed() {
    this.activatedViewMap = true;
    this.activatedViewPanoramic = true;
  }

  changeCreateActive() {
    //verificar formulario activo
    if (this.panoramicService.getCreateActive())
      this.panoramicService.setCreateActive(false);
    else this.panoramicService.setCreateActive(true);
  }

  onDragEnd(event: any) {
    this.splitAreaSizeMap = event.sizes[0];
    this.splitAreaSizePanoramic = event.sizes[1];
  }
}
